import type { ComponentProps } from 'react'
import GamingDetails from '../components/GamingDetails'

type Props = ComponentProps<typeof GamingDetails>

export default function Step3_GamingDetails(props: Props) {
  return <GamingDetails {...props} />
}

